import React, { useContext } from 'react';
import ym from 'react-yandex-metrika';

import { Main, ProblemCard } from '@/components';
import { Calendar, Car, Clock, Message, Service, Arrow } from '@/icons';
import { PageContext } from '@/Page';

import styles from './problems.module.scss';

const Problems: React.FC = () => {
  const { handleOpen, setCondition } = useContext(PageContext);
  const count = '8';
  const total = '10';
  const cards = [
    {
      id: 1,
      icon: Calendar,
      text: 'Нет свободного места для записи на СТО'
    },
    { id: 2, icon: Service, text: 'Долгий поиск и доставка запчастей' },
    {
      id: 3,
      icon: Clock,
      text: 'Долгая процедура согласования на всех этапах ремонта'
    },
    {
      id: 4,
      icon: Message,
      text: 'Долгое получение или отсутствие обратной связи о статусе ремонта'
    },
    { id: 5, icon: Car, text: 'Простои при выдаче' }
  ];

  const handleClick = () => {
    handleOpen();
    ym('reachGoal', 'choose_solution');
    setCondition(3);
  };

  return (
    <div className={styles.container}>
      <Main>
        <div className={styles.container__left}>
          <h2 className={styles.container__title}>
            <span className={styles.container__title_info}>{count}</span>
            {` из ${total}`}
          </h2>
          <p className={styles.container__text}>
            автопарков сталкиваются
            <br />
            <span className={styles.container__text_info}>с проблемами</span>
          </p>
        </div>
        <div className={styles.container__right}>
          {cards.map((card) => (
            <ProblemCard
              key={card.id}
              className={styles.container__card}
              icon={card.icon}
              text={card.text}
            />
          ))}

          <button
            className={styles.container__btn}
            type='button'
            onClick={handleClick}
          >
            <p className={styles.container__btnText}>
              Нашли в списке свою проблему? Оставьте заявку и мы подберем
              решение
            </p>
            <div className={styles.container__btnLine}>
              <p className={styles.container__btnName}>Подобрать решение</p>
              <Arrow />
            </div>
          </button>
        </div>
      </Main>
    </div>
  );
};

export default Problems;
